/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetUserCouponAvailablePageRespVo } from './PageDataGetUserCouponAvailablePageRespVo';
import {
    PageDataGetUserCouponAvailablePageRespVoFromJSON,
    PageDataGetUserCouponAvailablePageRespVoFromJSONTyped,
    PageDataGetUserCouponAvailablePageRespVoToJSON,
    PageDataGetUserCouponAvailablePageRespVoToJSONTyped,
} from './PageDataGetUserCouponAvailablePageRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetUserCouponAvailablePageRespVo
 */
export interface ResponsePageDataGetUserCouponAvailablePageRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetUserCouponAvailablePageRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetUserCouponAvailablePageRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetUserCouponAvailablePageRespVo}
     * @memberof ResponsePageDataGetUserCouponAvailablePageRespVo
     */
    data?: PageDataGetUserCouponAvailablePageRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetUserCouponAvailablePageRespVo interface.
 */
export function instanceOfResponsePageDataGetUserCouponAvailablePageRespVo(value: object): value is ResponsePageDataGetUserCouponAvailablePageRespVo {
    return true;
}

export function ResponsePageDataGetUserCouponAvailablePageRespVoFromJSON(json: any): ResponsePageDataGetUserCouponAvailablePageRespVo {
    return ResponsePageDataGetUserCouponAvailablePageRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetUserCouponAvailablePageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetUserCouponAvailablePageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetUserCouponAvailablePageRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetUserCouponAvailablePageRespVoToJSON(json: any): ResponsePageDataGetUserCouponAvailablePageRespVo {
    return ResponsePageDataGetUserCouponAvailablePageRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetUserCouponAvailablePageRespVoToJSONTyped(value?: ResponsePageDataGetUserCouponAvailablePageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetUserCouponAvailablePageRespVoToJSON(value['data']),
    };
}

